'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactI18next = require('react-i18next');

var _chemist = require('chemist');

var _FormInput = require('../FormInput');

var _CheckoutButtonStyle = require('./CheckoutButtonStyle.scss');

var _CheckoutButtonStyle2 = _interopRequireDefault(_CheckoutButtonStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CheckoutButton = (_dec = (0, _chemist.configurable)(), _dec2 = (0, _reactI18next.translate)(), _dec3 = (0, _reactCssModules2.default)(_CheckoutButtonStyle2.default, { allowMultiple: true }), _dec(_class = _dec2(_class = _dec3(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(CheckoutButton, _React$Component);

  function CheckoutButton() {
    (0, _classCallCheck3.default)(this, CheckoutButton);
    return (0, _possibleConstructorReturn3.default)(this, (CheckoutButton.__proto__ || (0, _getPrototypeOf2.default)(CheckoutButton)).apply(this, arguments));
  }

  (0, _createClass3.default)(CheckoutButton, [{
    key: 'buttonText',
    value: function buttonText() {
      var _props = this.props,
          t = _props.t,
          store = _props.config.store;


      switch (this.props.step) {
        case 'address':
          return store.skipCheckoutSteps.includes('delivery') ? t('spree.proceed_to_payment') : t('spree.proceed_to_delivery');
        case 'delivery':
          return t('spree.proceed_to_payment');
        case 'payment':
          return t('spree.place_order_pay');
        default:
          return t('spree.proceed');
      }
    }
  }, {
    key: 'paymentCopy',
    value: function paymentCopy() {
      var t = this.props.t;


      if (this.props.step !== 'payment') {
        return '';
      }

      return _react2.default.createElement(
        'p',
        { className: 't-text t-text--centered' },
        t('spree.submit_w_obligation')
      );
    }
  }, {
    key: 'renderTotalCost',
    value: function renderTotalCost() {
      if (!this.props.amount && !this.props.mobile) {
        return '';
      }

      return _react2.default.createElement(
        'p',
        { className: 't-text t-text--centered', styleName: 'a-costWithDelivery' },
        _react2.default.createElement(_reactI18next.Interpolate, {
          i18nKey: 'spree.total_incl_delivery',
          amount: this.props.displayTotal
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.paymentCopy(),
        this.renderTotalCost(),
        _react2.default.createElement(
          _FormInput.Button,
          null,
          this.buttonText()
        )
      );
    }
  }]);
  return CheckoutButton;
}(_react2.default.Component), _class2.propTypes = {
  displayTotal: _react.PropTypes.string,
  mobile: _react.PropTypes.bool,
  step: _react.PropTypes.string.isRequired
}, _class2.defaultProps = {
  mobile: false
}, _temp)) || _class) || _class) || _class);
exports.default = CheckoutButton;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/CheckoutForm/CheckoutButton.js
// module id = 2273
// module chunks = 0